export default "__VITE_ASSET__7rVxEThv__"